import { render, staticRenderFns } from "./formAli_oss.vue?vue&type=template&id=1d2a7162&"
import script from "./formAli_oss.vue?vue&type=script&lang=js&"
export * from "./formAli_oss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports